import React from "react";
import { Form, Input, Tooltip } from "antd";
const FormItem = Form.Item;

function formatNumber(value) {
  value += "";
  const list = value.split(".");
  const prefix = list[0].charAt(0) === "-" ? "-" : "";
  let num = prefix ? list[0].slice(1) : list[0];
  let result = "";
  while (num.length > 3) {
    result = `,${num.slice(-3)}${result}`;
    num = num.slice(0, num.length - 3);
  }
  if (num) {
    result = num + result;
  }
  return `${prefix}${result}${list[1] ? `.${list[1]}` : ""}`;
}

class NumericInput extends React.Component {
  onChange = e => {
    const { value, name } = e.target;
    const reg = /^-?(0|[1-9][0-9]*)(\.[0-9]*)?$/;

    if ((!isNaN(value) && reg.test(value)) || value === "" || value === "-") {
      this.props.onChange(name, value);
      // console.log(name, parseInt(value, 10));
    }
  };

  // '.' at the end or only '-' in the input box.
  onBlur = handleblur => {
    const { value, onBlur, onChange } = this.props;
    // console.log(value);
    if (value) {
      if (value.toString().charAt(value.length - 1) === "." || value === "-") {
        onChange({ value: value.slice(0, -1) });
      }
      if (onBlur) {
        onBlur();
      }
      handleblur();
    }
  };

  render() {
    const { name, value, placeholder, handleblur } = this.props;
    const title = value ? (
      <span className="numeric-input-title">
        {value !== "-" ? formatNumber(value) : "-"}
      </span>
    ) : (
      "Input a number"
    );
    return (
      <Tooltip
        trigger={["focus"]}
        title={title}
        placement="topLeft"
        overlayClassName="numeric-input"
      >
        <Input
          name={name}
          value={value}
          onChange={this.onChange}
          onBlur={() => this.onBlur(handleblur)}
          placeholder={placeholder}
          maxLength="25"
        />
      </Tooltip>
    );
  }
}

const NumericInputDemo = ({
  value,
  name,
  label,
  onChange,
  disabled = false,
  placeholder = "",
  errors,
  required,
  onBlurA
}) => (
  <FormItem
    // {...formItemLayout}
    label={label}
    validateStatus={errors[name] ? "error" : null}
    help={errors[name] || null}
    required={required}
  >
    <NumericInput
      name={name}
      value={value}
      onChange={onChange}
      handleblur={onBlurA}
      placeholder={placeholder}
    />
  </FormItem>
);

export default NumericInputDemo;



// WEBPACK FOOTER //
// ./src/Modules/FormFields/NumberField.js